import {
  bucketLayer,
  popLastRenderBatch,
  type Bucket,
} from './render';
import type { Tool } from './types';

type Input = { bucket?: Bucket };

export const renderUndo: Tool<Input> = {
  name: 'render_undo',
  description:
    'Remove the most recent batch of graphics added by the last `render` call in the given bucket (default "highlights"). Older batches in the same bucket are untouched. Returns the number of graphics removed (0 if nothing to undo).',
  input_schema: {
    type: 'object',
    properties: {
      bucket: { enum: ['highlights', 'markers', 'buffers'] },
    },
    additionalProperties: false,
  },
  execute: (input = {}) => {
    const bucket: Bucket = input.bucket ?? 'highlights';
    const layer = bucketLayer(bucket);
    if (!layer) throw new Error(`render_undo: graphics bucket "${bucket}" not initialised`);
    const popped = popLastRenderBatch(bucket);
    if (!popped || popped.length === 0) {
      return { undone: 0, bucket };
    }
    for (const g of popped) layer.remove(g);
    return { undone: popped.length, bucket };
  },
};
